module.exports = __webpack_public_path__ + "img/calendar-arrow-from.48d5bc5f.svg";